export default __webpack_public_path__ + "fire-extinguisher.png";